/*
  Mobile PDP add-to-cart (ClickUp 86d45e0hh): the button sits in its place in
  the product info; once the shopper scrolls past it, it becomes a bar pinned
  to the bottom of the screen; near the footer the bar slides away.

  Toggles two classes on each .product-des-wrapper .atc-quantity, styled in
  assets/product.css (and assets/pdp-tlpc.css for TLPC):
  - is-sticky: pinned to the bottom (the in-place button is above the screen).
  - is-at-footer: hidden while the footer is on screen.
  A placeholder before the button keeps its height in the page while it's
  pinned, so the content doesn't jump; a zero-height marker after it is what
  gets watched - thanks to the placeholder it stays at the in-place button's
  bottom edge whether the button is pinned or not, so the switch never
  flickers. Mobile only (768px and down, the
  breakpoint the CSS already used); desktop is untouched.
*/
(function () {
  var mobile = window.matchMedia('(max-width: 768px)');

  function setup(atc) {
    if (atc.dataset.stickyAtc) return;
    atc.dataset.stickyAtc = 'true';

    var placeholder = document.createElement('div');
    placeholder.className = 'atc-quantity-placeholder';
    placeholder.setAttribute('aria-hidden', 'true');
    atc.parentNode.insertBefore(placeholder, atc);

    var marker = document.createElement('div');
    marker.className = 'atc-quantity-marker';
    marker.setAttribute('aria-hidden', 'true');
    atc.parentNode.insertBefore(marker, atc.nextSibling);

    var passed = false; // in-place button scrolled up out of view
    var atFooter = false;

    function render() {
      var sticky = mobile.matches && passed;
      if (sticky && !atc.classList.contains('is-sticky')) {
        // Hold the button's space before it leaves the flow.
        placeholder.style.height = atc.offsetHeight + 'px';
      }
      atc.classList.toggle('is-sticky', sticky);
      atc.classList.toggle('is-at-footer', sticky && atFooter);
      if (!sticky) placeholder.style.height = '';
    }

    // Once the marker (the in-place button's bottom edge) is above the
    // screen, the button has been scrolled past.
    new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      render();
    }).observe(marker);

    var footer = document.getElementById('SiteFooter') || document.querySelector('.shopify-section-group-group-footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        atFooter = entries[entries.length - 1].isIntersecting;
        render();
      }).observe(footer);
    }

    if (mobile.addEventListener) {
      mobile.addEventListener('change', render);
    } else {
      mobile.addListener(render);
    }
  }

  function init() {
    if (typeof IntersectionObserver !== 'function') return;
    document.querySelectorAll('.product-des-wrapper .product__form__wrapper .atc-quantity').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
